import { useEffect, useRef, useState } from 'react';

import DropdownArrowIcon from 'assets/icons/arrowDown.svg';
import useResize from 'hooks/useResize';

export interface DropdownProps {
  title: string;
  children?: React.ReactElement;
  velocity?: number;
  updateHeight?: Record<string, boolean>;
}

export interface DropdownReset {
  resetHeight: boolean;
}

function Dropdown(props: DropdownProps) {
  const [isOpenState, setIsOpenState] = useState(false);
  const { windowWidth } = useResize();
  const dropdownContentRef = useRef<HTMLDivElement>(null);
  const dropdownInnerRef = useRef<HTMLDivElement>(null);

  const setDropdownHeight = (d: DropdownReset): void => {
    const dropdownContentEl = dropdownContentRef.current as HTMLDivElement;
    const dropdownInnerEl = dropdownInnerRef.current as HTMLDivElement;

    if (!d.resetHeight) {
      const contentHeight = dropdownInnerEl?.getBoundingClientRect().height || 0;
      const velocity = props.velocity || 960; // px/s

      dropdownContentEl.style.height = `${contentHeight}px`;
      dropdownContentEl.style.transitionDuration = `${contentHeight / velocity}s`;
    } else {
      dropdownContentEl.style.height = '0px';
    }
  };

  useEffect(() => {
    setDropdownHeight({ resetHeight: true });
    setIsOpenState(false);
  }, [windowWidth]);

  useEffect(() => {
    if (isOpenState) setDropdownHeight({ resetHeight: false });
  }, [props.updateHeight]);

  const handleClick = (isOpen: boolean) => {
    if (!isOpen) {
      setDropdownHeight({ resetHeight: false });
    } else {
      setDropdownHeight({ resetHeight: true });
    }
    setIsOpenState(!isOpen);
  };

  return (
    <div className={`ct_dropdown ${isOpenState ? '_open' : ''}`}>
      <div className="ct_dropdown-header" aria-hidden onClick={() => handleClick(isOpenState)}>
        <div className="ct_dropdown-title">{props.title}</div>
        <div className="ct_dropdown-icon">
          <DropdownArrowIcon />
        </div>
      </div>
      <div className="ct_dropdown-content" ref={dropdownContentRef}>
        <div className="ct_dropdown-inner" ref={dropdownInnerRef}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

Dropdown.defaultProps = { ...{} };

export default Dropdown;
